module.exports = __webpack_public_path__ + "static/media/cq_editor_sottolineato b.df246fca.svg";